import { types } from "./types";
import JWTEncode from "./JWTEncode/JWTEncode";
import JWTDecode from "./JWTDecode/JWTDecode";

function Actions(
    action,
    showAlert,
    variables,
    setOpenVariable,
    automId,
    variableRender
) {
    switch (action.actionName) {
        case types.JWTDECODE:
            return (
                <JWTDecode
                    action={action}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.JWTENCODE:
            return (
                <JWTEncode
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        default: break;
    }
}

export default Actions;
